module.exports = __webpack_public_path__ + "static/img/icon-not-applicable.f0e3ad7e.svg";